import QuoteGenerator from "./components/quotegenerator";
// import Footer from "./components/footer/footer";
import "./App.scss";

function App() {
  return (
    <div className="App">
      <QuoteGenerator />
      {/* <Footer /> */}
    </div>
  );
}

export default App;
